import { Calendar2 } from 'blaze-ui/icons'
import { Button } from './Button'
import { generatePath, useHistory } from 'react-router-dom'
import { useCallback } from 'react'
import { SCHEDULED_POSTS_PATH } from 'paths'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'
import { IconButton } from 'blaze-ui/IconButton/IconButton'
import { Calendar1 } from 'blaze-ui/icons/24'

export const CalendarButton = ({ iconOnly = false }: { iconOnly?: boolean }) => {
  const workspaceId = useCurrentWorkspaceId()
  const history = useHistory()

  const goToCalendar = useCallback(() => {
    const path = generatePath(SCHEDULED_POSTS_PATH, { workspaceId: workspaceId })
    history.push(path)
  }, [history, workspaceId])

  if (iconOnly) {
    return <IconButton icon={Calendar1} aria-label="Calendar" onPress={goToCalendar} variant="secondary" />
  }

  return (
    <Button icon={Calendar2} aria-label="Calendar" onPress={goToCalendar}>
      Calendar
    </Button>
  )
}
